import $ from "jquery";
import {flashMessage} from "./popups";

let serviceList = [];

let totalPriceValue = 0;

(async function () {
    try {
        const response = await fetch(route('api.services'));
        const {data} = await response.json();
        serviceList = data;
    } catch (e) {
        console.error(e);
        throw e
    }
})();

function findService(id) {
    const service = serviceList.find(serviceItem => serviceItem.id === Number.parseInt(id));

    if (!service) {
        console.error('Service not found', id);

        throw new Error('Service not found');
    }

    return service;
}

function findDetailForService(service, id) {
    const detail = service.details.find(detailItem => detailItem.id === Number.parseInt(id));

    if (!detail) {
        console.error('Detail not found', id);

        throw new Error('Detail not found');
    }

    return detail;
}

function closeAllSelect(element) {
    const items = document.querySelectorAll(".select-items");
    items.forEach(function (item) {
        if (element !== item.parentElement) {
            item.classList.add("select-hide");
        }
    });
}

function setLeftImage(image) {
    if (!image) {
        return;
    }

    const $imgElement = $('.left-panel__img img');
    $imgElement.fadeOut(300, function () {
        $imgElement.attr('src', image).on('load', function () {
            $(this).fadeIn(300);
        });
    });
}

function setTotalPrice(price) {
    const $priceOutput = $('.current-price__price');

    totalPriceValue = price;

    $priceOutput.text(price);
}

function calcTotalPriceForSelectedServices() {
    const $selectedServices = $('.select-selected');

    let totalPrice = 0;

    $selectedServices.each(function () {
        if (!$(this).attr('data-id')) {
            return;
        }

        if (!$(this).attr('data-service-id')) {
            // process selected service
            const selectedService = findService($(this).attr('data-id'));

            totalPrice += selectedService.price;
        } else {
            // process selected detail
            const service = findService($(this).attr('data-service-id'));
            const selectedDetail = findDetailForService(service, $(this).attr('data-id'));

            totalPrice += selectedDetail.price;
        }
    });

    return totalPrice;
}

function refreshTotalPrice() {
    let totalPrice = calcTotalPriceForSelectedServices();

    setTotalPrice(totalPrice);
}

// --------------------
// services

document.addEventListener("click", function (e) {
    if (!e.target.classList.contains('select-selected-service') && $("right-panel__wrapper").not('open')) {
        closeAllSelect();
        $('.select-selected-service').removeClass('rotate-arrow')
        $('.select-selected-details').removeClass('rotate-arrow')
    }
});

$(document).on('click', '.custom-select', function () {
    const $container = $(this).parents('.row-service');
    const servic = $container.find('#servic');

    servic.empty();

    // render services dropdown
    serviceList.forEach((serviceItem) => {
        servic.append(
            $('<div>')
                .addClass('service-items')
                .text(serviceItem.title)
                .attr('data-id', serviceItem.id)
        );
    });
});

$(document).on('click', '.delete-service', function () {
    const $rowService = $(this).closest('.row-service');
    const $prevRow = $rowService.prev('.row-service');
    const $nextRow = $rowService.next('.row-service');

    if ($('.row-service').length > 1) {
        $rowService.remove();
    }
    if ($nextRow.length === 0) {
        const $newAddServiceDiv = $(`<div class="add-service">${$t('site_labels.add_service')}</div>`);

        $prevRow.append($newAddServiceDiv);

        refreshTotalPrice()
    }
});

$(document).on("click", '.select-selected-service', function (e) {
    e.preventDefault()
    const $container = $(this).parents('.row-service');
    const $selectService = $container.find(".select-service");

    // Toggle the visibility of select-service
    $selectService.toggleClass("select-hide");
    $(this).toggleClass('rotate-arrow');
});

$(document).on('click', '.service-items', function () {
    const $container = $(this).parents('.row-service');
    $container.find('.select-selected-service').removeClass('rotate-arrow');

    const selectedService = findService($(this).attr('data-id'));

    setLeftImage(selectedService.image);

    $container.attr('data-id', selectedService.id);

    $container.find('.select-selected-service')
        .addClass('selected')
        .text(selectedService.title)
        .attr('data-id', selectedService.id);

    $container.find('#servic').addClass('select-hide');

    if (selectedService.hasDrop) {
        $container.find('.detail-label').removeClass('hide-item');
        $container.find('.detalis').removeClass('hide-item');

        renderDetailsForService($container, selectedService);
    } else {
        $container.find('.detail-label').addClass('hide-item');
        $container.find('.detalis').addClass('hide-item');

        $container.find('.select-selected-details').text($t('site_labels.select_detail'));
    }

    refreshTotalPrice()
});

function renderDetailsForService($container, service) {
    const $detailsContainer = $container.find('#detalis');

    $detailsContainer.empty();

    service.details.forEach((detailItem) => {
        $detailsContainer.append(
            $('<div>')
                .addClass('details-items1')
                .text(detailItem.title)
                .attr('data-id', detailItem.id)
                .attr('data-service-id', service.id)
        );
    });
}

$('.service-items').on('click', function () {
    const $container = $(this).parents('.row-service');
    $container.find('.select-service').addClass('select-hide');
});

// --------------------------
// details

$(document).on('click', '.select-selected-details', function () {
    const $container = $(this).closest('.row-service');
    $(this).toggleClass('rotate-arrow');
    const $selectItemsDetails = $container.find('.select-items.select-details');
    // Закриваємо або відкриваємо поточний вибір деталей
    $selectItemsDetails.toggleClass('select-hide');
});

$(document).on('click', function (event) {
    if (!$(event.target).closest('.row-service').length) {
        $('.select-items.select-details').addClass('select-hide');
    }
});

$(document).on('click', '.details-items1', function () {
    const $container = $(this).parents('.row-service');
    $container.find('.select-selected-details').removeClass('rotate-arrow');

    const service = findService($(this).attr('data-service-id'));
    const detail = findDetailForService(service, $(this).attr('data-id'));

    $container.find('.select-selected-details')
        .text(detail.title)
        .attr('data-id', detail.id)
        .attr('data-service-id', service.id);

    $('.select-items.select-details').addClass('select-hide');

    $container.find('#detalis').addClass('selected');

    setLeftImage(detail.image)

    refreshTotalPrice()
})

// ! add details
$(document).on('click', '.add-details', function () {
    $(this).hide()

    const $container = $(this).closest('.row-service');

    const service = findService($container.attr('data-id'))

    const $customSelectDetails = $('<div class="custom-select detalis"></div>')
        .append($(`<div class="select-selected select-selected-details">${$t('site_labels.select_detail')}</div>`))
        .append($('<div class="select-items select-hide select-details" id="detalis"></div>'))
        .append($('<div class="delete-details">-</div>'))
        .append($(`<div class="add-details">${$t('site_labels.add_detail')}</div>`));

    const $newRowContainer = $('<div class="row-service"></div>').attr('data-id', service.id)
        .append($customSelectDetails);

    $container.after($newRowContainer);

    renderDetailsForService($newRowContainer, service)
});

// delete detail row
$(document).on('click', '.delete-details', function () {
    const $rowService = $(this).closest('.row-service');

    $rowService.remove();

    refreshTotalPrice();
});

// -----------------------
// calculate button

$('#calculate-form__button').on('click', function () {
    $('.right-panel__wrapper-content').addClass('hide').removeClass('show');
    $('.right-panel__wrapper-content__calc').addClass('show').removeClass('hide');

    refreshTotalPrice()
    $('.final-value__price').text(totalPriceValue);
})

// -----------------------
// clear all button

$('.clear-all').on('click', function () {
    const $rows = $('.row-service');
    if ($rows.length > 1) {
        for (let i = 1; i < $rows.length; i++) {
            const currentRow = $rows.eq(i);
            if (!currentRow.hasClass('add-service')) {
                currentRow.remove();
            }
        }
        $rows.first().append(`<div class="add-service">${$t('site_labels.add_service')}</div>`);
    }

    setTotalPrice(0);

    $rows.eq(0).find('.select-selected').text($t('site_labels.select_service'));

    flashMessage($t('site_labels.input_fields_cleared_successfully'))
});
